module.exports = __webpack_public_path__ + "static/img4new-58d0f030dc8e666d87a6bc74cf6067d0.jpg";